import GraduationHeadshot from "../images/grad-headshot.png";
import styles from '../Style'
import {createUseStyles} from "react-jss";
import useMobile from "../../../template/Mobile";
const useStyle = createUseStyles(styles);
export default function Education() {
    const style = useStyle();
    return <div className={style.portfolioSectionHorizontalFlex}>
        <div className={style.portfolioSectionText}>
            <h3>B.S. Computer Science</h3>
            <p>📍 <a href={"https://www.fit.edu/"}>Florida Institute of Technology, Melbourne, FL</a></p>
            <p>🗓️ Graduated Fall 2024</p>
            <p>🎓 GPA: 3.95</p>
            <p>Relevant Courses:</p>
            <ul>
                <li>Data Structures and Algorithms</li>
                <li>Studies in Artificial Intelligence</li>
                <li>Analysis of Algorithms</li>
                <li>Web Applications</li>
            </ul>
        </div>
        <img className={style.sectionImage} src={GraduationHeadshot}/>
    </div>
}